import React from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import FlexBox from "../../components/Shared/FlexBox";
import brands from "../../brands.json";

const CompoundBrand = styled(FlexBox)`
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  padding: 80px 20px;
  background-color: #fafafa;

  picture,
  img {
    width: 100%;
    &[data-ref="cover"] {
      max-width: 600px;
      max-height: 400px;
      margin-bottom: 40px;
      border-radius: 15px;
      object-fit: cover;
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }
    &[data-ref="kv"] {
      object-fit: cover;
      margin-bottom: 40px;
    }
  }

  h2, h3, h4 {
    text-align: center;
    margin: 10px 0;
  }

  h2 {
    font-size: 1.8rem;
    color: #333;
  }

  h3 {
    font-size: 1.4rem;
    color: #555;
  }

  h4 {
    font-size: 1.1rem;
    color: #d89669;
  }

  p {
    max-width: 720px;
    width: 100%;
    line-height: 1.8;
    letter-spacing: 0.6px;
    text-align: left;
    white-space: pre-line;
    color: #444;
    background: #fff;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.05);
    margin-bottom: 30px;
  }

  a {
    display: inline-flex;
    margin: 15px 0 40px 0;
    padding: 10px 20px;
    background-color: #d89669;
    color: white;
    border-radius: 10px;
    text-decoration: none;
    font-weight: bold;
    transition: all 0.2s ease;
    &:hover {
      background-color: #b56c3c;
    }
  }

  @media (max-width: 767px) {
    p {
      font-size: 0.95rem;
      padding: 15px;
    }
    h2 {
      font-size: 1.5rem;
    }
  }
`;

const PageBrand = () => {
  let { id } = useParams();
  const cafe = brands.find((c) => c.id === Number(id));

  if (!cafe) {
    return (
      <CompoundBrand>
        <h2>找不到該品牌資料</h2>
      </CompoundBrand>
    );
  }

  return (
    <CompoundBrand>
      {/* 頁首 KV */}
      <picture data-ref="kv">
        <source
          media="(max-width: 767px)"
          srcSet={'https://i.meee.com.tw/UCNjOiH.jpg'}
        />
        <img data-ref="kv" src={'https://i.meee.com.tw/2QiXNCj.jpg'} alt="品牌主視覺" />
      </picture>

      {/* 品牌主圖 */}
      {cafe.img && <img data-ref="cover" src={cafe.img} alt={cafe.name} />}

      {/* 品牌名稱 */}
      <h2>{cafe.name}</h2>

      {/* 地址 */}
      {cafe.address && (
        <>
          <h3>地址</h3>
          <p>{cafe.address}</p>
        </>
      )}

      {/* 電話 */}
      {cafe.tel && (
        <>
          <h3>電話</h3>
          <p>{cafe.tel}</p>
        </>
      )}

      {/* 訂位資訊 */}
      {cafe.booking && (
        <>
          <h3>訂位資訊</h3>
          <p>{cafe.booking}</p>
        </>
      )}

      {/* 分店資訊 */}
      {cafe.branch && (
        <>
          <h3>分店資訊</h3>
          <p>{cafe.branch}</p>
        </>
      )}

      {/* 主打產品 */}
      {cafe.product && (
        <>
          <h3>主打產品：{cafe.product}</h3>
          <p>{cafe.product_summary}</p>
        </>
      )}

      {/* 優惠資訊 */}
      {cafe.offer && (
        <>
          <h3>優惠活動：{cafe.offer}</h3>
          <p>{cafe.offer_summary}</p>
        </>
      )}

      {/* 官方連結 */}
      {cafe.url && (
        <a href={cafe.url} target="_blank" rel="noreferrer noopener">
          瞭解更多
        </a>
      )}
    </CompoundBrand>
  );
};

export default PageBrand;
